export { HotelBookInformation } from './HotelBookInformation';
